import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  ButtonLink,
  InputCnpj,
  InputEmail,
  InputSecret,
  InputText,
} from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { validateCompanySignUp } from "@helpers/signUp";
import { focusFirstError } from "../Common/FormPage";
import { PublicBox, PublicBoxFooter, PublicFields, PublicPage, submitOnEnter } from "../Common/PublicPage";
import PasswordRequirements from "./PasswordRequirements";

// Cadastro público da empresa: quem cadastra vira o administrador dela
export default function SignUp() {
  const authService = useService("auth");
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", cnpj: "", email: "", pass: "" });
  const [loading, setLoading] = useState(false);
  // Os erros aparecem nos campos depois da primeira tentativa e se atualizam a cada mudança
  const [submitted, setSubmitted] = useState(false);

  const errors = submitted ? validateCompanySignUp(values) : {};
  const change = (field) => (e) => setValues((prev) => ({ ...prev, [field]: e.target.value }));

  async function handleSubmit() {
    if (loading) return;
    setSubmitted(true);
    const found = validateCompanySignUp(values);
    if (Object.keys(found).length) {
      focusFirstError(Object.keys(found));
      return;
    }

    setLoading(true);
    const res = await authService.createNewUser(values);

    if (res && !res.error) {
      toast.success("Cadastro finalizado com sucesso!");
      setTimeout(() => navigate("/auth/entrar"), 3000);
      return;
    }

    // A mensagem do back (e-mail ou CNPJ já cadastrado etc.) já saiu no toast do service
    setLoading(false);
  }

  return (
    <PublicPage title="Cadastro" description="Sugerimos usar o e-mail que você utiliza no trabalho.">
      <PublicBox onKeyDown={submitOnEnter(handleSubmit)}>
        <PublicFields>
          <InputText
            $idForm="sign-up-name"
            $label="Nome da empresa"
            $variant="default"
            $errors={errors["sign-up-name"]}
            placeholder="Ex.: Onework LTDA"
            value={values.name}
            onChange={change("name")}
          />
          <InputCnpj
            $idForm="sign-up-cnpj"
            $label="CNPJ"
            $variant="default"
            $errors={errors["sign-up-cnpj"]}
            value={values.cnpj}
            onChange={change("cnpj")}
          />
          <InputEmail
            $idForm="sign-up-email"
            $label="E-mail"
            $variant="default"
            $errors={errors["sign-up-email"]}
            autoComplete="email"
            placeholder="joao@onework.com"
            value={values.email}
            onChange={change("email")}
          />
          <InputSecret
            $idForm="sign-up-pass"
            $label="Senha"
            $variant="default"
            $errors={errors["sign-up-pass"]}
            autoComplete="new-password"
            value={values.pass}
            onChange={change("pass")}
          />
          <PasswordRequirements password={values.pass} />
        </PublicFields>
        <PublicBoxFooter>
          <ButtonLink $text="Já tem uma conta? Entrar" $action={() => navigate("/auth/entrar")} />
          <Button $text="Cadastrar" $variant="primary" $action={handleSubmit} $isLoading={loading} />
        </PublicBoxFooter>
      </PublicBox>
    </PublicPage>
  );
}
